import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import { Typography, TextField, MenuItem } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
  },
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  itemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  itemInput: {
    width: '240px',
  },
}));

const SelectCompanyType = props => {
  const { 
    className, 
    contracts,
    types,
    valueContract,
    onChangeContract, 
    valueType,
    onChangeType, 
    style, 
    ...rest } = props;

  const classes = useStyles();

  return (
    <div className={classes.row}>

        {/* <Typography
          className={classes.itemTitle}
          color="textSecondary"
          gutterBottom
        >
          계약 상태
        </Typography> */}

        <TextField
          className={classes.itemInput}
          id="outlined-select-agency"
          required 
          select
          label="계약 상태"
          value={valueContract}
          onChange={onChangeContract}
          helperText=""
          //variant="outlined"
          margin="dense"
        >
          {contracts.map(contract => (
            <MenuItem key={contract.label} value={contract.value}>
              {contract.label}
            </MenuItem>
          ))}
        </TextField>

        <div style={{width: 36}}>

        </div>

        {/* <Typography
          className={classes.itemTitle}
          color="textSecondary"
          gutterBottom
        >
          사업장 구분
        </Typography> */}
        <TextField
          className={classes.itemInput}
          id="outlined-select-client"
          required 
          select
          label="사업장 구분"
          value={valueType}
          onChange={onChangeType}
          helperText=""
          //variant="outlined"
          margin="dense"
          //helperText="* 광고대행사선택후 선택하세요"
        >
          {types.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

      </div>
  );
};

SelectCompanyType.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
};

export default SelectCompanyType;
